// extracted by mini-css-extract-plugin
module.exports = {"container":"_1BjZvq84HEVBzlIXQ2gfsv","visible":"_3yOTwlw8aPX3PaUnhp9CQF","cancelBtn":"_1ViDzEqTORofsiwA7xmuoq","icon":"_12JVkB2WWG0Mz8_1QzBnBJ","saveBtn":"_3naMt5r0AA5AiHWWRP1HLR"};